export default "__VITE_ASSET__f68697ae__"